var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personal-attention"},[_vm._l((_vm.attentionList),function(item,index){return [_c('div',{staticClass:"item",on:{"click":function($event){return _vm.skipDetails(item)}}},[_c('img',{attrs:{"src":item.banner,"alt":""}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(item.name))])])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19cdffd9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal/MyAttention.vue
// module id = null
// module chunks = 